import React, { useState } from 'react';
import { recordControlClick } from '../shared/tapCount';

/**
 * Scroll, pause, then tap. Logout and Show Completed use the same row.
 * The old control keeps the tasks-screen button so the two can be compared.
 * Counts are logged as [tap] and stored on window.__pacarionClicks.
 */
const filler = Array.from({ length: 24 }, (_, index) => index + 1);

const rowStyle = {
  width: '100%',
  padding: '1rem 1.25rem',
  border: 'none',
  background: '#fff',
  color: '#1a1a1a',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  fontSize: '1rem',
  fontWeight: 500,
  fontFamily: 'inherit',
  minHeight: '56px',
  textAlign: 'left',
  boxSizing: 'border-box',
};

export default function TapCheckPage() {
  const [completed, setCompleted] = useState(false);
  const [oldCompleted, setOldCompleted] = useState(false);
  const [logoutCount, setLogoutCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [oldCount, setOldCount] = useState(0);

  return (
    <div className="app-scroll" style={{ minHeight: '100%', background: '#f7fbfb', color: '#1a1a1a' }}>
      <header style={{ padding: '1rem 1.25rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.4rem' }}>Tap check</h1>
        <p style={{ margin: '0.5rem 0 0' }}>Scroll this page, pause, then tap each row.</p>
      </header>
      {filler.map((item) => (
        <p key={item} style={{ margin: 0, padding: '1rem 1.25rem' }}>{'Line ' + item}</p>
      ))}
      <div style={{ background: '#fff', border: '1px solid #d5e4e4', padding: 0, margin: '1rem' }}>
        <button
          type="button"
          className="app-menu-row"
          data-testid="tap-logout"
          onClick={() => {
            const count = recordControlClick('logout', process.env);
            setLogoutCount(count);
          }}
          style={rowStyle}
        >
          <span style={{ flex: 1, textAlign: 'left' }}>Logout</span>
        </button>
      </div>
      <div style={{ background: '#fff', border: '1px solid #d5e4e4', padding: 0, margin: '1rem' }}>
        <button
          type="button"
          className="app-menu-row"
          data-testid="tap-show-completed"
          onClick={() => {
            const count = recordControlClick('show-completed', process.env);
            setCompletedCount(count);
            setCompleted((current) => !current);
          }}
          style={rowStyle}
        >
          <span style={{ flex: 1, textAlign: 'left' }}>
            {completed ? 'Hide Completed' : 'Show Completed'}
          </span>
        </button>
      </div>
      <div style={{ margin: '1rem', display: 'flex' }}>
        <button
          type="button"
          className="native-tap"
          data-testid="tap-show-completed-old"
          onClick={() => {
            const count = recordControlClick('show-completed-old', process.env);
            setOldCount(count);
            setOldCompleted((current) => !current);
          }}
          style={{
            padding: '0.625rem 1.25rem',
            background: oldCompleted ? '#59c4c4' : '#fff',
            color: oldCompleted ? 'white' : '#1a1a1a',
            border: '1px solid #d5e4e4',
            borderRadius: '1.25rem',
            cursor: 'pointer',
            touchAction: 'manipulation',
            fontSize: '0.95rem',
            fontWeight: oldCompleted ? '600' : 'normal',
            minHeight: '44px',
            transition: 'all 0.2s',
          }}
        >
          {oldCompleted ? 'Hide Completed' : 'Show Completed'}
        </button>
      </div>
      <p role="status" style={{ padding: '0 1.25rem 3rem' }}>
        {'Logout clicks ' + logoutCount + '. Show Completed clicks ' + completedCount + '. Old control clicks ' + oldCount + '.'}
      </p>
      {filler.map((item) => (
        <p key={'after-' + item} style={{ margin: 0, padding: '1rem 1.25rem' }}>{'After ' + item}</p>
      ))}
    </div>
  );
}
